import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import links from 'utils/links';

const styles = theme => ({
    container: {
        textAlign: "center", //theme.spacing.unit,
        padding : 5*theme.spacing.unit,
        height : window.innerHeight
    },
});


class CheckRoleAuth extends React.Component {
  render(){
    let loginJson = {
        "msg" : "Looks like you need to login to access this page!!",
        "link" : "loginLink",
        "buttonContent" : "Login and Access"
    };
    let permissionJson = {
        "msg" : "Looks like you need to Permission to access this page!!",
        "link" : "home",
        "buttonContent" : "Go to Home"
    }
    let finalJson = this.props.roleProps.accessTo ? permissionJson : loginJson;
    const { classes } = this.props;
    console.log(finalJson);
    return ( 
        <div className={classes.container}>
            <h3>{finalJson.msg}</h3>
            <Link to={links[finalJson.link]()}>
                <Button
                    variant="contained"
                    color="secondary"
                >
                    {finalJson.buttonContent}
                </Button>
            </Link>
        </div>
    )
  }
    
};
export default withStyles(styles)(CheckRoleAuth);
